export const ProcessResultLabel = {
  1: '未处理',
  2: '已处理',
  3: '未处理',
  4: '已信任',
}
export enum ProcessResult{
  Untreated = 1,
  Processed = 2,
  Trusted = 4
}
export const ProcessSearchResultLabel = {
  1: '未处理',
  2: '已处理',
  // 3: '处理失败',
  4: '已信任',
}
export const quarantineStatusLabel = {
  1: '已修复',
  2: '未修复',
}
